import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * 메인 화면 하단의 이용 안내.
 * 고객센터(/service) 의 도식화된 6단계와 같은 모양을 쓴다. 다만 메인에서는
 * 한 줄에 2개씩 놓아 위쪽 견적·버스 안내(maxWidth 900)와 폭을 맞춘다.
 * 글자 수가 달라도 칸 크기가 들쭉날쭉하지 않도록 격자로 폭을 나누고
 * 높이는 stretch 로 서로 맞춘다.
 */
const USE_STEPS = [
  { no: '01', main: '견적요청 · 전화상담' },
  { no: '02', main: '상담 후 견적서 제공', sub: '(전화, 메일, SMS 문자)' },
  { no: '03', main: '계약금 입금 · 계약서 작성' },
  { no: '04', main: '배차', sub: '(1일~3일 전)' },
  { no: '05', main: '배차 후 기사님 확인전화' },
  { no: '06', main: '당일 출발' },
];

const UseNotice = () => {
  return (
    <Box
      component='section'
      sx={{ width: '100%', maxWidth: 900, m: 'auto', mt: '2em', mb: '3em', px: 2 }}
    >
      <Typography
        component='h2'
        sx={{
          p: '10px',
          mb: '24px',
          borderRadius: '10px',
          backgroundColor: '#EC9F46',
          color: '#FCFCFC',
          fontWeight: 700,
          textAlign: 'center',
        }}
      >
        이용 안내
      </Typography>

      <Box
        component='ol'
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(2, 1fr)',
          gap: { xs: 1.2, md: 2 },
          alignItems: 'stretch',
          listStyle: 'none',
          m: 0,
          p: 0,
        }}
      >
        {USE_STEPS.map((step) => (
          <Box
            component='li'
            key={step.no}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 0.3,
              minHeight: { xs: '5.2em', md: '5.8em' },
              px: { xs: 1.2, md: 2 },
              py: { xs: 1.4, md: 2 },
              border: '2px solid #5A4231',
              borderRadius: '20px',
              boxSizing: 'border-box',
              textAlign: 'center',
              wordBreak: 'keep-all',
            }}
          >
            <Typography
              component='span'
              sx={{ fontSize: { xs: 11, md: 13 }, fontWeight: 700, letterSpacing: '0.06em', color: '#EC9F46' }}
            >
              {step.no}
            </Typography>
            <Typography
              component='span'
              sx={{ fontSize: { xs: 14, md: 16 }, lineHeight: 1.45, color: '#1C1A1A' }}
            >
              {step.main}
            </Typography>
            {step.sub && (
              <Typography component='span' sx={{ fontSize: { xs: 11.5, md: 13 }, color: 'gray' }}>
                {step.sub}
              </Typography>
            )}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default UseNotice;
